import { render, staticRenderFns } from "./ModalBasic.vue?vue&type=template&id=74fd1fcf"
import script from "./ModalBasic.vue?vue&type=script&lang=js"
export * from "./ModalBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports